<template>
  <div class="d-flex align-center px-2">
    <v-btn :loading="loading" small icon @click="scan()">
      <v-icon medium class="barcode-icon">
        mdi-barcode-scan
      </v-icon>
    </v-btn>
  </div>
</template>
<style scoped>
.barcode-icon {
  height: 40x !important;
  font-size: 40px !important;
  width: 40px !important;
  position: relative;
  left: -3px;
  color: #ffffff !important;
}
</style>
<script>
export default {
  name: "Barcode",
  props: ["formats"],
  data() {
    return {
      loading: false
    };
  },
  computed: {},
  methods: {
    scan() {
      if (window.cordova && window.cordova.plugins.barcodeScanner) {
        try {
          this.loading = true;
          // eslint-disable-next-line no-undef
          cordova.plugins.barcodeScanner.scan(
            result => {
              if (result) {
                console.log("BarCode Read: ", result.text);
                this.loading = false;
                this.$emit("input", {
                  type: "Barcode",
                  name: result.text
                });
              }
            },
            error => {
              this.loading = false;
              console.error("Scanning failed", error);
            },
            {
              showFlipCameraButton: true,
              showTorchButton: true,
              resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
              formats:
                this.formats ||
                "EAN_8,EAN_13,CODE_128,CODE_39,CODE_93,CODABAR,UPC_A,UPC_E"
            }
          );
        } catch (err) {
          console.log(err);
        }
      }
    }
  }
};
</script>
